const MAX_LISTED_NAMES = 3;

function joinWithAnd(parts: ReadonlyArray<string>): string {
    if (parts.length === 0) {
        return '';
    }
    const [only] = parts;
    if (parts.length === 1) {
        return only ?? '';
    }
    return `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}

/**
 * Render a list of names for prose, eliding the tail past a few entries.
 *
 * An outreach contacts up to 300 caregivers, so any surface listing them by
 * name has to bound itself: an uncapped join turns a one-line status into a
 * wall of text. Counts are never elided, only names, so the reader always
 * learns how many were involved.
 */
export function formatNameList(names: ReadonlyArray<string>): string {
    if (names.length <= MAX_LISTED_NAMES) {
        return joinWithAnd(names);
    }
    const remaining = names.length - MAX_LISTED_NAMES;
    return joinWithAnd([
        ...names.slice(0, MAX_LISTED_NAMES),
        `${remaining} other${remaining === 1 ? '' : 's'}`,
    ]);
}
